import styled from "styled-components";
import MaskedTextInput from "react-text-mask";

export const InputGroup = styled("div")(({ theme }) => ({
  width: "100%",
}));

export const Label = styled("label")(({ theme }) => ({
  width: "100%",
  fontSize: 10,
  paddingLeft: 15,
  paddingTop: 2,
  color: theme.palette.input.labelText,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",

  [theme.down("sm")]: {
    fontSize: 9,
    paddingLeft: 12,
  },
}));

export const InputBlock = styled("div")(({ theme, isError, isSuccess }) => ({
  ...theme.mixins.flexColumn,
  position: "relative",
  height: 50,
  borderRadius: 4,
  backgroundColor: theme.palette.white,
  border: `1px solid ${isError ? theme.palette.input.borderError : theme.palette.input.border}`,
  ...(isSuccess ? { borderLeftWidth: 3, borderLeftColor: theme.palette.input.borderSuccess } : {}),
  ...(isError ? { backgroundColor: theme.palette.input.errorBg } : {}),
  transition: "all .2s ease",

  "&:focus-within": {
    borderColor: isError ? theme.palette.input.borderError : theme.palette.input.borderFocus,
    boxShadow: isError
      ? `0 0 0 3px ${theme.palette.input.errorShadow}`
      : `0 0 0 3px ${theme.palette.input.focusShadow}`,
  },
}));

export const InputElement = styled("input")(({ theme }) => ({
  ...theme.paddings(10, 30, 0, 15),
  position: "absolute",
  width: "100%",
  height: "100%",
  border: "none",
  lineHeight: 1,
  backgroundColor: "transparent",
  fontSize: 16,

  "&:hover, &:active, &:focus": {
    outline: "none",
  },

  "&::placeholder": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    color: theme.palette.fly.placeholder,
  },

  [theme.down("sm")]: {
    fontSize: 14,
    ...theme.paddings(10, 15, 0, 12),

    "&::placeholder": {
      fontSize: 13,
    },
  },
}));

export const MaskedInputElement = styled(MaskedTextInput)(({ theme }) => ({
  ...theme.paddings(10, 30, 0, 15),
  position: "absolute",
  width: "100%",
  height: "100%",
  border: "none",
  lineHeight: 1,
  backgroundColor: "transparent",
  fontSize: 16,

  "&:hover, &:active, &:focus": {
    outline: "none",
  },

  "&::placeholder": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    color: theme.palette.fly.placeholder,
  },

  [theme.down("sm")]: {
    fontSize: 14,
    ...theme.paddings(10, 15, 0, 12),

    "&::placeholder": {
      fontSize: 13,
    },
  },
}));

export const Error = styled("div")(({ theme }) => ({
  color: theme.palette.input.errorText,
  fontSize: 14,
  marginTop: 4,
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: 4,
  animation: "slideDown 0.2s ease-out",

  "@keyframes slideDown": {
    from: {
      opacity: 0,
      transform: "translateY(-4px)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
  },

  [theme.down("sm")]: {
    fontSize: 13,
  },
}));
